import { Skeleton } from '@mantine/core';

import ContestNotificationWidget from '~/domains/contest/domains/common/components/ContestNotificationWidget/ContestNotificationWidget';

import { useHomeGroupInvites } from '../hooks/useHomeGroupInvites';

function HomeGroupInviteWidget({ isFullWidth }: { isFullWidth?: boolean }) {
  const { groupInvitesProps, isGroupInvitesLoading } = useHomeGroupInvites();

  if (isGroupInvitesLoading && !groupInvitesProps) {
    return <Skeleton height={54} />;
  }

  if (!groupInvitesProps) {
    return null;
  }

  return <ContestNotificationWidget {...groupInvitesProps} isFullWidth={isFullWidth} />;
}

export default HomeGroupInviteWidget;
